var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 21.0609 39.5678 22.0783 38.7984 22.8284C38.029 23.5786 36.9855 24 35.8974 24H4.10256C3.0145 24 1.97099 23.5786 1.20161 22.8284C0.432233 22.0783 0 21.0609 0 20C0 18.9391 0.432233 17.9217 1.20161 17.1716C1.97099 16.4214 3.0145 16 4.10256 16H35.8974C36.9855 16 38.029 16.4214 38.7984 17.1716C39.5678 17.9217 40 18.9391 40 20Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.3eb49a4ad18ba234a20b66784d315b16.svg";
export { ForwardRef as ReactComponent };